import {
  addDays,
  differenceInSeconds,
  isSameDay,
  parseISO,
  startOfDay,
} from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { type Currency, type Lootbox, LootboxStage } from '@/api/common';
import { USER_GROUP } from '@/helpers/user';
import { getCurrencyCentsAndCode } from '@/helpers/wallet';

export const FORTUNE_WHEEL_RESTRICTED_GROUPS = [
  USER_GROUP.BA,
  USER_GROUP.BR,
  USER_GROUP.LOW_BET_LIMIT,
];

export const SPINS_PER_DAY = 3;

export enum WheelStatusEnum {
  Loading = 'loading',
  Spinning = 'spinning',
  Finished = 'finished',
}

export const isToday = (date: string): boolean => {
  const createdAtDate = toZonedTime(parseISO(date), 'UTC');
  const currentUtcDate = toZonedTime(new Date(), 'UTC');

  return isSameDay(createdAtDate, currentUtcDate);
};

export const getTimeUntilNextDay = (): number => {
  const currentUtcTime = toZonedTime(new Date(), 'UTC');
  const nextDayUtc = startOfDay(addDays(currentUtcTime, 1));

  return differenceInSeconds(nextDayUtc, currentUtcTime);
};

export const convertMaxWin = (
  values: { currency: string; amountCents: number }[],
  currencies: Currency[]
): string => {
  const amountsMap: { [key: string]: string[] } = {};

  const maxWinCurrencies = values.map((value) =>
    getCurrencyCentsAndCode(value.amountCents, value.currency, currencies)
  );

  maxWinCurrencies.forEach((item) => {
    if (amountsMap[item.amount]) {
      amountsMap[item.amount].push(item.currency);
    } else {
      amountsMap[item.amount] = [item.currency];
    }
  });

  return Object.entries(amountsMap)
    .map(
      ([amountCents, currencies]) => `${amountCents} ${currencies.join('/')}`
    )
    .join(', ');
};

export const getSpinsLeftAmount = (
  lootboxes: Lootbox[],
  spinsPerDay = SPINS_PER_DAY
) => {
  const currentLootboxes = lootboxes.filter((lootbox) =>
    isToday(lootbox.createdAt)
  );

  const activatedLootboxes = [...currentLootboxes].filter(
    (lootbox) => lootbox.stage === LootboxStage.Activated
  );

  return spinsPerDay - activatedLootboxes.length;
};

export const formatLootboxItemTitle = (str: string): string =>
  str.split(' ').slice(-2).join(' ');
